import { render, staticRenderFns } from "./IcraEmri151Taslak.vue?vue&type=template&id=5930da63"
import script from "./IcraEmri151Taslak.vue?vue&type=script&lang=ts"
export * from "./IcraEmri151Taslak.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports